<script>
// import ReportCard from '@/views/live/components/ReportCard'
import ReportFilter from '@/views/live/components/ReportFilter'
import { breadcrumbEventBus } from '@/main'
import LiveReportService from '@/services/ReportModules/LiveReportService'
import UserService from '@/services/UserService'
import LocationSummaryCard from '@/views/live/components/LocationSummaryCard'

export default {
  created () {
    this.location_id = this.$route.params.location_id
    this.location = UserService.getLocationById(this.$route.params.location_id)
  },
  data () {
    return {
      comparison: 'lastweek',
      location: {},
      trends: {},
      summary: {}
    }
  },
  updated: function () { },
  mounted () {
    if (!location > 0) {
      this.$updateloading(-99)
      this.$router.push('/live', () => {
        this.$notify({
          group: 'errors',
          title: 'Invalid Location Selected',
          type: 'error'
        })
      })
    }
    this.$updateloading(1)
    // LiveReportService.locationHistoricData(this.location).then(data => {
    //   this.trends = data.trends
    //   this.$updateloading(-1)
    // })
    LiveReportService.getLocation(this.location_id).then(data => {
      this.summary = data
      this.setBreadcrumb()
      this.$updateloading(-1)
    })
  },
  methods: {
    onGetComparison: function (comparison) {
      this.comparison = comparison
    },
    calculatePercentDifference: function (summarydata, compnumber, daystart, hourstop) {

    },
    laborGoalNumber: function (jobId) {
      if (this.location.schedule && this.location.schedule[jobId]) {
        return this.location.schedule[jobId].formulaValue
      } else {
        return null
      }
    },
    setBreadcrumb: function () {
      const breadcrumb = []
      breadcrumb.push({ link: '/live/home', title: 'Home' })
      breadcrumb.push({
        link: null,
        title: this.location.name
      })
      breadcrumbEventBus.$emit('breadcrumbChanged', breadcrumb)
    }
  },
  components: {
    LocationSummaryCard,
    ReportFilter
  }
}
</script>

<template>
  <div>
    <report-filter
      :comparison="comparison"
      @updateComparison="onGetComparison"
    ></report-filter>
    <LocationSummaryCard
      :comparison="comparison"
      :location="location"
    ></LocationSummaryCard>
  </div>
  <!--<div>
   <report-filter :comparison="comparison" @updateComparison="onGetComparison"></report-filter>
  <div v-if="location" class="row">
    <div class="col-sm-12 col-lg-6">
      <div class="well">
        <div class="list-group">
          <router-link :to="`/live/location/${location_id}/sales`" class="list-group-item active">
            <span class="list-group-item-heading">Sales Summary</span>
          </router-link>
          <div class="list-group-item" v-if="summary.sales">
            <div class="row">
              <div class="col-sm-12 col-md-6 table-responsive">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <th colspan="3" class="text-center">Total Sales</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Net Sales:</td>
                      <td class="text-right">{{summary.sales.net | formatNumber('$0,0.00')}}</td>
                      <td>

                      </td>
                    </tr>
                    <tr>
                      <td>Gross Sales:</td>
                      <td class="text-right">{{ summary.sales.gross | formatNumber('$0,0.00') }}</td>
                      <td>

                      </td>
                    </tr>
                    <tr>
                      <td>Discounts:</td>
                      <td class="text-right">{{ summary.sales.discount | formatNumber('$0,0.00') }}</td>
                      <td>
                      </td>
                    </tr>
                    <tr v-if="summary.sales">
                      <td>Tax:</td>
                      <td class="text-right">{{ summary.sales.tax | formatNumber('$0,0.00') }}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-12 col-md-6 table-responsive">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <th colspan="3" class="text-center">Ticket Info</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Total Tickets:</td>
                      <td class="text-right">{{ summary.sales.totalcheckcount }}</td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td>Total Guests:</td>
                      <td class="text-right">{{ summary.sales.guestcount }}</td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td>Open Tickets:</td>
                      <td class="text-right">{{ summary.sales.opencheckcount }}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Current Guests:</td>
                      <td class="text-right">{{ summary.sales.guestcurrent }}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center col-xs-12">
              <router-link :to="`/live/location/${location_id}/sales`"></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="well">
        <div class="list-group">
          <router-link :to="`/live/location/${location_id}/labor`" class="list-group-item active">
            <span class="list-group-item-heading">Labor Summary</span>
          </router-link>
          <div class="list-group-item">
            <div class="row">
              <div v-if="summary.labor" class="col-sm-12 col-md-6 table-responsive">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <th colspan="3" class="text-center">Total Labor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Amount:</td>
                      <td class="text-right">{{ summary.labor.laborcost | formatNumber('$0,0.00') }}</td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td>Hours Logged:</td>
                      <td class="text-right">{{ summary.labor.hours | formatNumber('0,0.00') }}</td>
                      <td>
                      </td>
                    </tr>
                    <tr>
                      <td>Employees:</td>
                      <td class="text-right">{{ summary.labor.employees | formatNumber('0,0') }}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Clocked In:</td>
                      <td class="text-right">{{ summary.labor.clocked_in | formatNumber('0,0') }}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-sm-12 col-md-6 table-responsive">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <th colspan="3" class="text-center">On The Clock</th>
                    </tr>
                    <tr v-if="summary.schedule">
                      <th>Job Type</th>
                      <th class="text-center">&num;</th>
                      <th class="text-center">Needed</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(clock, index) in summary.clocked" :key="index">
                      <td>{{ clock.name }}</td>
                      <td class="text-right">{{ clock.count }}</td>
                      <td class="text-right">
                        <span v-if="clock.needed != 0">
                          <span class="fas fa-arrow-down text-danger" v-if="clock.count > clock.needed">
                            {{ clock.count - clock.needed }}
                          </span>
                          <span class="fas fa-arrow-up text-info" v-if="clock.count < clock.needed">
                            {{ clock.needed - clock.count }}
                          </span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center col-xs-12">
              <router-link :to="`/live/location/${location_id}/labor`">View Labor Details</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>
<style scoped>
body {
  background-color: #3d3d3d;
}
</style>
